// extracted by mini-css-extract-plugin
export var menuItem = "F_wx d_fZ d_by d_bC d_bN d_bd";
export var menuItemSub = "F_wy d_Y d_by d_bN";
export var menuMainLink = "F_wz d_f0 d_dz";
export var menuLink = "F_wB d_f0 d_dz";
export var icon = "F_pD d_bB d_bN";
export var divider = "F_wC d_bB d_bN";
export var sublinks = "F_wD";
export var link = "F_mC";
export var Link = "F_sM x_sM x_r5 x_sq";